import React from 'react';
import Loader from 'utils/Loader';
import { Box, Grid, TextField } from '../../../node_modules/@mui/material/index';
import BeatsController from '../Controller/BeatsController';
import { useNavigate } from 'react-router-dom';

const Beats = () => {
    const { cloading, beats, showCustomers, selectedDate,
        setSelectedDate, } = BeatsController();
    const today = new Date().toISOString().split('T')[0];
    const navigate = useNavigate();
    return (
        <div className="bg" style={{ display: 'block' }}>
            {/* Loader */}
            {cloading ? (
                <div className="overlay">
                    <Loader />
                    <span style={{ marginLeft: '10px' }}>Please Wait....</span>
                </div>
            ) : null}

            <div className="cutrange">
                <span className="font20">BEATS</span>
            </div>
            <div className="cutrange" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <span className="font20"></span>
                <button
                    style={{
                        padding: '8px 16px',
                        color: 'white',
                        border: 'none',
                        borderRadius: '4px',
                        cursor: 'pointer',
                        width: '250px'
                    }}
                    onClick={() => navigate('/beat-planning')} // Replace with your navigation
                >
                    Beat Planning
                </button>
            </div>

            <div style={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                width: '100%',
                margin: '20px 0',
                padding: '10px',
                borderRadius: '4px'
            }}>
                <TextField
                    type="date"
                    InputLabelProps={{
                        shrink: true
                    }}
                    inputProps={{
                        max: today // disable future dates
                    }}
                    value={selectedDate}
                    style={{
                        width: '250px',
                        maxWidth: '90%',
                        backgroundColor: 'white',
                        borderRadius: '4px'
                    }}
                    onChange={(e) => setSelectedDate(e.target.value)}
                />
            </div>

            <div>
                {beats.length === 0 && (
                    <Box fullWidth sx={{ textAlign: 'center' }}>
                        <span>No Beats Found For this user.</span>
                    </Box>
                )}

                <Box fullWidth>
                    <Grid container spacing={3}>
                        {beats.map((beat, index) => (
                            <Grid item xs={12} sm={4} md={2} xl={2} key={index}>
                                <Box style={{ backgroundColor: 'white', borderRadius: '10px', padding: '0.8rem', boxSizing: 'borderBox' }} onClick={() => showCustomers(beat.beat_code)}>
                                    <h3 style={{ textAlign: 'center', color: 'black' }}>{beat.beat_code}</h3>
                                    {/* <div style={{ width: '100%', textAlign: 'center' }}>
                                        <span style={{ color: 'black', textAlign: 'center' }}>{beat.beat_name}</span>
                                    </div> */}
                                </Box>
                            </Grid>
                        ))}
                    </Grid>
                </Box>

            </div>
        </div>

    );
};

export default Beats;
